module.exports = __webpack_public_path__ + "img/16@2x.0779a771.png";